import React from "react";
import NoImage from "../../assets/images/noimages.jpg";
import serviceImg from "../../assets/images/tyre.svg";
import loader from "../../components/loader/loader";
import { APIURL } from "../../redux/action/config";
const ViewMembership = ({ viewDetails, modalId }) => {
  const membership = viewDetails ? viewDetails : "";

  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                {viewDetails && membership?._id ? (
                  <form
                    id="kt_modal_new_target_form"
                    className="form fv-plugins-bootstrap5 fv-plugins-framework"
                  >
                    <div className="mb-8 text-center">
                      <h1 className="mb-3 text-primary">Membership Detail</h1>
                    </div>
                    <div className="separator d-flex flex-center mb-8"></div>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Profile Picture</span>
                        </label>
                        <div>
                          <img
                            className="mw-150px"
                            src={membership.image ? APIURL + "/" + membership.image : NoImage}
                            alt="profile"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Membership Name </span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership.name ? membership.name : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Membership Yearly Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership.price ? `${membership.price}` : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Membership Monthly Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership.priceMonthly
                            ? `${membership.priceMonthly}`
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Membership Daily Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership.priceDaily
                            ? `${membership.priceDaily}`
                            : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Membership 1-7 Day Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership.price1to7Days
                            ? `${membership.price1to7Days}`
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Membership 7-30 Day Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership.price7to30Days
                            ? `${membership.price7to30Days}`
                            : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Allowed Orders</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.order_Counts
                            ? membership?.order_Counts
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Car Price</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership.car ? membership.car : "N/A"}
                        </div>
                      </div> */}
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Car Price</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.vehiclePrice
                            ? membership?.vehiclePrice
                            : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Motorcycle/ATV Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.motorcyclePrice
                            ? membership?.motorcyclePrice
                            : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Golf Cart Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.golfCartPrice
                            ? membership?.golfCartPrice
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Bicycle Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.bicyclePrice
                            ? membership?.bicyclePrice
                            : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Vehicle Limit under Price</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.vehicleLimit
                            ? membership?.vehicleLimit
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>No. of Dependent users allowed</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.additionalDrivers
                            ? membership?.additionalDrivers
                            : "N/A"}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Price for adding Dependent user($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.additionalDriversPrice
                            ? membership?.additionalDriversPrice
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    {/*<div className="row mb-5">
                       <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Motorcycle/ATV Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.motorcyclePrice
                            ? membership?.motorcyclePrice
                            : "N/A"}
                        </div>
                      </div> 
                      {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Motorcycle Atv Price($)</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.motorcycleAtvPrice
                            ? membership?.motorcycleAtvPrice
                            : "N/A"}
                        </div>
                      </div> 
                    </div>*/}
                    <div className="col-md-12  mb-5 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Waiting Period</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {membership?.waitingPeriod
                          ? membership?.waitingPeriod
                          : "N/A"}
                      </div>
                    </div>
                    <div className="col-md-12  mb-5 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Services</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {membership?.services?.map((item, index) => {
                          return (
                            <div key={index} className="service-item">
                              <img
                                src={item?.image ? (APIURL + "/" + item.image) : serviceImg}
                              />
                              {item?.name ? item?.name : "N/A"} 
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Description</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {membership?.description
                            ? membership?.description
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </form>
                ) : (
                  <div className="spinner-outer p-5">{loader()}</div>
                )}
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewMembership;
